<template>
  <div>
    <div v-for="(folder, index) in folders" :key="index">
      <div class="sf-level">
        <div
          class="sf-level-item sf-font-l"
          style="margin-right: 0; padding-right: 14px"
          @click="toggleFolder(folder)"
        >
          <div
            v-show="!hasSubfolders(folder)"
            style="visibility: hidden; width: 12px"
          ></div>
          <div
            v-show="hasSubfolders(folder) && !folder.closed"
            class="icon icon-caret-down"
            style="width: 12px"
          ></div>
          <div
            v-show="hasSubfolders(folder) && folder.closed"
            class="icon icon-caret-right"
            style="width: 12px"
          ></div>
        </div>
        <div
          class="
            sf-level-item-full
            sf-level
            sf-layer-border
            sf-bg-white
            sf-pad-1
            sf-pad-h-2
          "
        >
          <div class="sf-level-item">
            <div
              class="
                i-documents-folder
                documents-document-icon
                sf-font-m sf-c-light
              "
            >
              <div
                v-if="folder.private"
                class="
                  icon-eye-slash
                  documents-document-icon
                  documents-lock-icon
                  documents-eye-slash-icon-overlay
                  document-selector-eye-slash-icon-overlay
                "
              ></div>
            </div>
          </div>
          <div v-if="folder.editable" class="sf-level">
            <div class="sf-level-item">
              <input
                v-model="folder.title"
                class="sf-form-input"
                placeholder="Folder title"
              />
            </div>
            <div class="sf-level-item">
              <sf-checkbox
                :model-value="!folder.private"
                label="Visible for Pulse users"
                @input="(v) => (folder.private = !v.target.checked)"
              ></sf-checkbox>
            </div>
          </div>
          <div v-else class="sf-level-item">{{ folder.title }}</div>
          <div v-if="!folder.editable && folder.private" class="sf-level-item">
            <div class="sf-dim-el">(not visible for Pulse users)</div>
          </div>
          <div class="sf-level-item-full"></div>
          <div class="sf-level-item">
            <div
              class="sf-btn sf-btn-primary sf-btn-small"
              @click="addSubTo(folder)"
            >
              Add sub-folder
            </div>
          </div>
          <div class="sf-level-item">
            <div
              class="sf-btn sf-btn-danger sf-btn-small"
              @click="deleteWithSubs(folder)"
            >
              Remove
            </div>
          </div>
        </div>
      </div>
      <div v-show="hasSubfolders(folder) && !folder.closed" class="sf-pad-l-3">
        <sf-folders :folders="folder.sub_folders"></sf-folders>
      </div>
    </div>
  </div>
</template>

<script>
import SfCheckbox from '@app/shared/vue/components/sf-checkbox'

// WARNING If you come here for inspiration for your own components, this is
// not the best example:
//
// There is a bunch of shortcuts that have been taken in this component and
// it's parent FirmDefaultPermanentCategories in index.js:
// - modify the props directly
// - abuse $forceUpdate
// - make API call directly in method
// It could be done in a more proper way, but it would involve the use of a
// Vuex store, which would increase complexity, and since this is for an admin
// special action that is not supposed to evolved, the shortcuts have been
// deemed acceptable.

const Folders = {
  name: 'SfFolders',
  components: {
    SfCheckbox,
  },
  props: {
    folders: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    hasSubfolders(folder) {
      return folder.sub_folders && folder.sub_folders.length > 0
    },
    toggleFolder(folder) {
      folder.closed = !folder.closed
      this.reRender()
    },
    deleteWithSubs(folder) {
      this.folders.splice(this.folders.indexOf(folder), 1)
      this.reRender()
    },
    addSubTo(folder) {
      const folderToAddTo = this.folders.find((f) => f.title === folder.title)
      folderToAddTo.sub_folders = folderToAddTo.sub_folders || []
      folderToAddTo.sub_folders.unshift({
        title: '',
        private: true,
        editable: true,
      })
      this.reRender()
    },
    reRender() {
      this.$parent.reRender()
    },
  },
}

export default Folders
</script>
